import React, { Fragment, useEffect, useState } from "react";
import {
  AsyncCallArgs,
  BlockText,
  CircularLoader,
  GridContainer,
  GridItem,
  HtmlParseText,
  isNotEmpty,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { ViewDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/serviceDefinitionControl";
import { useTranslation } from "react-i18next";
import { getContentManagementDataById } from "../../../../../../axios/api/services";
import { Alert } from "@mui/material";

const Content = ({ loading, error, definition }) => {
  const { t } = useTranslation();

  if (loading) {
    return <CircularLoader />;
  }

  if (error) {
    return <Alert severity="error">{t("m.error.serverFetchingError")}</Alert>;
  }
  return (
    <Fragment>
      <GridContainer spacing={5}>
        <GridItem sm={12} md={12}>
          <BlockText label={"l.serviceDefinition.id"} text={t(`m.${definition.id}`)} />
        </GridItem>
        <GridItem sm={12} md={12}>
          <HtmlParseText
            text={definition.content}
            styleArray={{ pointerEvents: "none" }}
            label={"l.serviceDefinition.description"}
          />
        </GridItem>
      </GridContainer>
    </Fragment>
  );
};

const ServiceDefinitionViewDialog = () => {
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [definition, setDefinition] = useState(null);

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.serviceDefinitionControl.modals.view;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "view" }));
  };

  useEffect(() => {
    if (open) {
      if (isNotEmpty(id)) {
        const asyncCallArgs: AsyncCallArgs = {
          promise: getContentManagementDataById(id),
          onSuccess: (response) => {
            setDefinition({ id: id, content: response.content });
            setLoading(false);
          },
          onError: () => {
            setError(true);
            setLoading(false);
          },
        };
        asyncCall(asyncCallArgs);
      } else {
        setDefinition(null);
        setLoading(false);
      }
    }
  }, [asyncCall, id, open]);

  return (
    <ViewDialog open={open} onClose={handleCloseDialog} title={"t.service.definition.view.dialog"}>
      <Content loading={loading} error={error} definition={definition}></Content>
    </ViewDialog>
  );
};

export default ServiceDefinitionViewDialog;
